import React, { useState } from 'react';
import { EmailCollect } from './EmailCollect';

const FloatingEmailBubble = () => {
  const [isExpanded, setIsExpanded] = useState(true); // Starts expanded
  const [formSubmitted, setFormSubmitted] = useState(false);

  const toggleBubble = () => {
    setIsExpanded(!isExpanded);
  };

  const stopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevents clicks inside from propagating
  };

  const handleFormSubmit = () => {
    setFormSubmitted(true);
  };

  return (
    <div className={`floating-bubble ${isExpanded ? 'expanded' : ''}`} onClick={!isExpanded ? toggleBubble : undefined}>
      {isExpanded ? (
        <div className="email-collection" onClick={stopPropagation}>
          {!formSubmitted && (
            <div className="email-text">Sign up for our mailing list to stay up to date!</div>
          )}
          <EmailCollect onSubmit={handleFormSubmit} />
          <button className="close-button" onClick={toggleBubble}>Close</button>
        </div>
      ) : (
        <span className="bubble-icon">✉️</span>
      )}
    </div>
  );
};

export default FloatingEmailBubble;
